import React from 'react';
import './MobileApps.css';
import { OffersDataService } from '../../../services/offers-data.service';

export const MobileApps = () => {
    const { mainImage, title, subtitle, android, ios } = OffersDataService.getOffersData();

    return (<section className="homepage-mobile-apps-container">
        <div className="homepage-mobile-apps-left-part">
            <img src={mainImage} alt="MainImage" loading="lazy" className="homepage-mobile-apps-image"/>
        </div>

        <div className="homepage-mobile-apps-right-part">
            <div className="homepage-mobile-apps-title">{title}</div>
            <div className="homepage-mobile-apps-text">{subtitle}</div>

            <div className="homepage-mobile-apps-items">
                {ios && <a href={ios} target="_blank" rel="noreferrer">
                    <div className="homepage-mobile-apps-items__ios"/>
                </a>}
                {android && <a href={android} target="_blank" rel="noreferrer">
                    <div className="homepage-mobile-apps-items__android"/>
                </a>}
            </div>
        </div>
    </section>);
};
